import { capitalizeWords } from '.';

export const INPUT_TITLES = {
  authorization: 'Service',
  callIndicator: 'Will Call',
  effectiveDate: 'Effective date',
  expirationDate: 'Expiration date',
  executionDate: 'Execution date',
  loadDuration: 'Load Duration',
  unloadDuration: 'Unload Duration',
  // the audit log shows these raw, so the unit is spelled out
  waitDuration: 'Wait Duration (seconds)',
  actualDuration: 'Actual Duration (seconds)',
  lob: 'Line of Business',
  modeOfTransport: 'Level of Service',
  authRequired: 'Auth required',
  category: 'Category',
  type: 'Service type',
  approvedService: 'Approved service',
  noteDetail: 'Note detail',
  unitsAllowed: 'Allowed',
  authorizationNumber: 'Authorization number',
  methodVerified: 'Method verified',
  planCode: 'Plan code',
  groupCode: 'Group code',
  status: 'Status',
  template: 'Survey template',
  shortNotes: 'Short note',
  bucketEndUnits: 'Unit end',
  bucketStartUnits: 'Unit start',
  bucketFreeUnits: 'Free units',
  baseRate: 'Base rate',
  unitRate: 'Unit Rate',
  equipmentAndAddon: 'Add On',
  hcpcOrBillingCode: 'Billing Code',
  insuranceBroker: 'Insurance broker',
  insuranceInsurer: 'Insurance Carrier',
  limitAggregate: 'Aggregate',
  limitOccurrence: 'Per Occurrence',
  issuing: 'Issuing authority',
  dob: 'Date of birth',
  ssh: 'SSN/TIN',
  ownership: 'Percent of ownership',
  inspectedDate: 'Inspection date',
  inspectionOrganization: 'Inspection Organization',
  deathDay: 'Date of Death',
  notes: 'Notes',
  number: 'Number',
  secContact: 'Secondary contact',
  contactExt: 'Contact extension',
  secContactExt: 'Secondary contact extension',
  secContactType: 'Secondary contact type',
  beforeChange: 'Original Value',
  afterChange: 'New Value',
  actionTime: 'Changed',
  timestamp: 'Viewed',
  modeOfTransportId: 'Level of service',
  lobId: 'Line of business',
  lineOfBusinessId: 'Line of business',
  limitTypeId: 'Limit type',
  statusId: 'Status',
  noteCategory: 'Note Category',
  // TODO this is for filtration to work!
  // payor: 'payer',
  payors: 'payers',
  // TODO this is for activity only
  payorInfo: 'payer',
};

export const formatFieldTitle = (fieldName: string): string => {
  const predefinedTitle = INPUT_TITLES[fieldName as keyof typeof INPUT_TITLES];
  if (predefinedTitle) return predefinedTitle;

  if (/^[a-z]+([A-Z][a-z]*)*$/.test(fieldName)) {
    return capitalizeWords(fieldName.replace(/([A-Z])/g, ' $1'));
  }

  if (/[_-]/.test(fieldName)) {
    return capitalizeWords(fieldName.replace(/[_-]/g, ' '));
  }

  if (/^[a-zA-Z]+$/.test(fieldName)) {
    return capitalizeWords(fieldName);
  }

  return '';
};

// labels shown in the permissions tables, also used to filter them
export const getPermissionLabels = (permission: {
  module?: string;
  name: string;
}) => ({
  module: capitalizeWords(
    formatFieldTitle(permission?.module ? permission.module.toLowerCase() : '')
  ),
  tab: formatFieldTitle(permission.name),
});
